<div class="person-groups-result">
  <!-- Members view -->
  <ng-container *ngIf="members() as membersData; else groupsView">
    <div class="members-header" *ngIf="!resultsService.isOverlay()">
      <span class="members-title">{{ membersData.groupName }}</span>
      <span class="members-count"
        >{{ membersData.count }} / {{ membersData.totalCount }}
        {{ 'PERSON_GROUPS_RESULT.MEMBERS' | translate }}</span
      >
    </div>

    <div class="members-grid">
      <ui-person-tile
        *ngFor="let p of membersData.persons"
        [ngModel]="isPersonSelected(p.personId)"
        (ngModelChange)="updatePersonSelection(p.personId, $event)"
        [disabled]="isPersonRemoving(p.personId)"
        [label]="p.name || '#' + p.personId"
        [imageUrl]="p.bestImage"
        [imageUrlFallback]="p.bestImage"
        [showCheckbox]="p.personId != null && !isPersonRemoving(p.personId)"
        [showConfirmationStatus]="true"
        [isConfirmed]="p.trainingStatus === 1"
        (confirm)="recognize(p)"
      >
        <div class="flex-row gap-4">
          <ui-button
            iconClass="ui-icon-edit"
            type="secondary"
            [rounded]="true"
            [matTooltip]="'COMMON.EDIT' | translate"
            matTooltipClass="sidebar-tooltip"
            (clickAction)="edit(p)"
          ></ui-button>
          <ui-button
            iconClass="ui-icon-delete"
            type="secondary"
            [rounded]="true"
            [matTooltip]="'PERSON_GROUPS.DETAIL.REMOVE_FROM_GROUP' | translate"
            matTooltipClass="sidebar-tooltip"
            [disabled]="isPersonRemoving(p.personId)"
            (clickAction)="remove(p)"
          ></ui-button>
        </div>
      </ui-person-tile>
    </div>

    <div *ngIf="membersData.persons.length === 0" class="empty-state">
      {{ 'PERSON_GROUPS_RESULT.EMPTY_MEMBERS' | translate }}
    </div>

    <ui-selected-items-snackbar
      *ngIf="selectedPersonsCount() > 0"
      [counter]="selectedPersonsCount()"
      [selectedText]="'PERSONS.PERSONS_SELECTED'"
      (selectAll)="selectAllDisplayedPersons()"
      (clearAll)="clearSelectedPersons()"
    >
      <ui-button
        [text]="'COMMON.DELETE' | translate"
        type="secondary"
        [loading]="hasRemovingSelectedPersons()"
        [disabled]="hasRemovingSelectedPersons()"
        (clickAction)="removeSelectedMembers()"
      ></ui-button>
    </ui-selected-items-snackbar>
  </ng-container>

  <!-- Groups list view -->
  <ng-template #groupsView>
    <div class="groups-header">
      <span class="groups-count" *ngIf="groups().length > 0"
        >{{ groups().length }}
        {{ 'PERSON_GROUPS_RESULT.GROUPS' | translate }}</span
      >
      <button
        type="button"
        class="header-open-btn"
        [matTooltip]="'PERSON_GROUPS.CREATE' | translate"
        (click)="createGroup()"
      >
        <span class="ui-icon-plus"></span>
      </button>
      <button
        type="button"
        class="header-open-btn"
        [matTooltip]="'PERSON_GROUPS_RESULT.OPEN_GROUPS' | translate"
        (click)="openGroupsPage()"
      >
        <span class="ui-icon-new-tab"></span>
      </button>
    </div>

    <div class="table-wrapper" *ngIf="groups().length > 0">
      <ui-dataset-table
        [data]="groups()"
        [config]="groupsTableConfig()"
        (rowAction)="onGroupRowAction($event)"
      ></ui-dataset-table>
    </div>

    <div *ngIf="groups().length === 0" class="empty-state">
      {{ 'PERSON_GROUPS_RESULT.EMPTY' | translate }}
    </div>
  </ng-template>
</div>
